export const filedsMapList = {
  typeid: {
    list: 'classifyList',
    label: 'path_name',
    value: 'id'
  },
  label_ids: {
    list: 'labelList',
    label: 'label_name',
    value: 'id'
  },
  publisher_id: {
    list: 'authorList',
    label: 'name',
    value: 'id'
  },
}
